import { generateDataToDownload } from 'pxc-editor-web/environment_modules/xcore/helpers/presenter';
import { isWebComponentEnvironment } from '@/helpers';

export const getSnapshotFromState = state => {
  const {
    pages,
    pagesOrder,
    paginationPageNum,
    pagesSelection,
    shieldsSelection,
    sectionsSelection,
    viewboxY,
    viewboxX,
    zoomState,
    scaleCoef,
    cellSelectionType,
    groupSelectionType,
    fictiveSections,
    fictiveSectionsSelection,
    laserOutputQuality,
    cmmeStates,
    autoFillMatrixTemplate
  } = state;

  return JSON.stringify({
    pages,
    pagesOrder,
    paginationPageNum,
    pagesSelection,
    shieldsSelection,
    sectionsSelection,
    viewboxY,
    viewboxX,
    zoomState,
    scaleCoef,
    cellSelectionType,
    groupSelectionType,
    fictiveSections,
    fictiveSectionsSelection,
    laserOutputQuality,
    cmmeStates,
    autoFillMatrixTemplate
  });
};

export const getStateFromSnapshot = snapshot => {
  return JSON.parse(snapshot);
};

export const setUnsavedProjectToLocalStorage = project => {
  try {
    localStorage.setItem('unsaved-project', project);
  } catch (error) {
    console.error(`Unable to save unsaved project to local storage: ${error.message}`);
  }
};

export const removeProjectFromLocalStorage = () => {
  try {
    localStorage.removeItem('unsaved-project');
  } catch (error) {
    console.error(`Unable to remove project from local storage: ${error.message}`);
  }
};

export const getUnsavedProjectFromLocalStorage = () => {
  const localStorageProject = localStorage.getItem('unsaved-project');
  if (localStorageProject) {
    const project = JSON.parse(localStorageProject);
    const [major, minor, patch] = process.env.VERSION_CONTROL.split('.').map(item => +item);
    // reset local storage in order to discard incorrect behavior
    // if (project?.project_version?.creator_app_version?.patch === patch) {
    //   return project;
    // }
    return project;
  }
  return null;
};

export const setProjectToStorage = () => () => {
  if (isWebComponentEnvironment()) {
    setUnsavedProjectToLocalStorage(JSON.stringify(generateDataToDownload({ isSave: false })));
  }
}
